<script setup>
import { forgeView } from '@/utils/forge-helpers/general'

import ConfluenceMacroSettingsModalFooter from '@jira/views/confluence-macro-settings/ConfluenceMacroSettingsModalFooter'
import ConfluenceMacroSettingsModalHeader from '@jira/views/confluence-macro-settings/ConfluenceMacroSettingsModalHeader'

defineOptions({
  name: 'ConfluenceMacroSettingsModalLayout'
})

defineProps({
  disableSaveButton: {
    type: Boolean
  }
})

const emit = defineEmits({
  close: null,
  cancel: null,
  save: null
})
</script>

<template>
  <div class="cms-Layout">
    <ConfluenceMacroSettingsModalHeader
      v-if="forgeView"
      class="cms-Layout_Header"
      @close="emit('close')"
    />

    <div class="cms-Layout_Body">
      <slot />
    </div>

    <ConfluenceMacroSettingsModalFooter
      v-if="forgeView"
      :disable-save-button="disableSaveButton"
      class="cms-Layout_Footer"
      @cancel="emit('cancel')"
      @save="emit('save')"
    />
  </div>
</template>

<style lang="scss" scoped>
.cms-Layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
}

.cms-Layout_Body {
  width: 100%;
  padding: var(--ob-cms-layout-body-padding, 20px);
  flex-grow: 1;
}

.cms-Layout_Header,
.cms-Layout_Footer {
  flex-shrink: 0;
}
</style>
